export async function postData(route = '', data = {}) {
  try {
      const url = `/.netlify/functions/${route}`;
      const response = await fetch(url, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json'
        },
        redirect: 'follow', 
        body: JSON.stringify(data) 
      });
      if (response.ok) {
        return response.json();
      }
    } catch (err) {
      // do nothing on error
    }
    return null;
  }